export default __webpack_public_path__ + "static/selectedAvatarRing-73a6169e07cbad9f4b7bd091a4640ec6.png";